import classNames from 'classnames';
import React, {ReactNode} from 'react';

import './Body.scss';

export interface BodyProps {
  children?: ReactNode;
  noHorizontalPadding?: boolean;
  limitMaxWidth?: boolean;
}

export const Body: React.FC<BodyProps> = ({ children, noHorizontalPadding, limitMaxWidth }) => {
  return (
    <div
      className={classNames('content-wrapper-body', {
        'content-wrapper-body--no-horizontal-padding': noHorizontalPadding,
        'content-wrapper-body--limit-max-width': limitMaxWidth,
      })}
    >
      {children}
    </div>
  );
};
